import React from 'react';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

import styles from './CountrySecondSection.module.css'

import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { orange, pink, green } from "@material-ui/core/colors";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={4}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    // backgroundColor: theme.palette.background.paper,
    width: 700,
  },
  bg: {
      backgroundColor: "#ffffff",
  },
  btn: {
      backgroundColor: "#5BCFC5"
  },
}));





export default function SecondSectionTabs() {
  const classes = useStyles();
//   const theme = useTheme();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  const theme = createMuiTheme({
    overrides: {
      MuiTabs: {
        indicator: {
          backgroundColor: "#5BCFC5"
        },
      },
    }
  });

  return (
    <MuiThemeProvider theme={theme}>
    <div className={classes.root}>
      <AppBar position="static" className={classes.bg}>
        <Tabs
          value={value}
          onChange={handleChange}
          textColor="primary"
          variant="fullWidth"
          aria-label="full width tabs example"
        >
          <Tab label="Visa Checklist" {...a11yProps(0)} style={{outline: "none"}}  />
          <Tab label="Covid-19 Info" {...a11yProps(1)} style={{outline: "none"}} />
          <Tab label="Finance" {...a11yProps(2)} style={{outline: "none"}} />
          <Tab label="Others" {...a11yProps(3)} style={{outline: "none"}} />
        </Tabs>
      </AppBar>
      <SwipeableViews
        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
        index={value}
        onChangeIndex={handleChangeIndex}
        
      >
        <TabPanel value={value} index={0} dir={theme.direction} >
            <div className={styles.box}>
                <h1 className={styles.head}>
                Visa application form
                </h1>
                <p className={styles.des}>
                Fully completed and signed application form with additional family information form
                </p>
            </div>
            <div className={styles.box}>
                <h1 className={styles.head}>
                Original Passport
                </h1>
                <p className={styles.des}>
                The passport must be valid at least 6 months after the intended date of departure from the territory of the destination country and has at least 2 blank visa pages.
                </p>
            </div>
        </TabPanel>
        <TabPanel value={value} index={1} dir={theme.direction}>
          Item Two
        </TabPanel>
        <TabPanel value={value} index={2} dir={theme.direction}>
          Item Three
        </TabPanel>
        <TabPanel value={value} index={3} dir={theme.direction}>
          Item Three
        </TabPanel>
      </SwipeableViews>
    </div>
    </MuiThemeProvider>
  );
}
